export const ADD_PARTICLES_OPTIONS = 'ADD_PARTICLES_OPTIONS';

export function AddParticlesOptions(options){
    return {
        type:ADD_PARTICLES_OPTIONS,
        payload:options
    }
} 